import type { EditorElement } from '@wix/component-protocol/schema';
import type { CompRef } from '@wix/document-services-types';
import { AbstractInternalContainerOverride } from './AbstractInternalContainerOverride';
import { SimpleContainerOverride } from './SimpleContainerOverride';
import { MENU_ITEMS_DEFAULT_SIMPLE_CONTAINER } from '../../constants/containerDefaults';
import type { EditorPointer } from '@wix/editor-document-logic-api';

export class MenuItemsContainerOverride extends AbstractInternalContainerOverride {
  resolve(
    editorPointer: EditorPointer<CompRef>,
    _containerOwnerPointer: EditorPointer<CompRef>,
    editorElement: EditorElement,
  ): EditorElement | null {
    if (!this.containerPlatformService.isMenuItemsContainer(editorPointer)) {
      return null;
    }
    return SimpleContainerOverride.applySimpleContainerOverrides(
      MENU_ITEMS_DEFAULT_SIMPLE_CONTAINER,
      editorElement,
    );
  }
}
